import {CLOSE_MSG, OPEN_MSG} from './msgTypes';

const initialState = {
   open: false,
   mensaje: '',
   accionAceptar: null,
   aceptarLabel: 'Eliminar'
};

function msgReducer(state = initialState, action) {
   switch (action.type) {
      case OPEN_MSG:
         return {...state, open: true, ...action.payload};
      case CLOSE_MSG:
         return initialState;
      default:
         return state;
   }
}

export default msgReducer;
